import { AxiosAdapter } from "../commons/adapters";

const http = new AxiosAdapter();



export const getAreasRatingsService = async (status?: number) => {
    try {
        const query = status !== undefined ? `?status=${status}` : '';
        return await http.get<any>(`/v1/ratings/areas-ratings${query}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('getAreasRatingsService ', error);
    }
}


export const getAreasRatingsPaginatedService = async (page: number = 0, status?: number) => {
    try {
        console.log('speee ', typeof status)
        const query = status !== undefined ? `&status=${status}` : '';
        return await http.get<any>(`/v1/ratings/areas-ratings?page=${page}&take=10${query}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('getAreasRatingsPaginatedService ', error); 
    }
}

export const getAreasRatingDetailService = async (id: string) => {
    try {
        return await http.get<any>(`/v1/ratings/areas-ratings/${id}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('getAreasRatingDetailService ', error);
    }
}

export const getAreasRatingsBySearchService = async (param: string, status?: number) => {
    try {
        const query = status !== undefined ? `?status=${status}` : '';
        return await http.get<any>(`/v1/ratings/areas-ratings/search/${param}${query}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('getAreasRatingsBySearchService ', error);
    }
}

export const createAreasRatingService = async (payload: any) => {
    try {
        return await http.postLogin<any>(`/v1/ratings/areas-ratings`, payload);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('createAreasRatingService ', error);
    }
}

export const updateAreasRatingService = async (id: string, payload: any) => {
    try {
        return await http.put<any>(`/v1/ratings/areas-ratings/${id}`, payload);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('updateAreasRatingService ', error);
    }
}

export const deleteAreasRatingService = async (id: string, value?: string, page: number = 1, status?: number) => {
    try {
        return await http.deleteTable<any>(`/v1/ratings/areas-ratings/${id}`, {
            param: value || '',
            page: page,
            status: status
        });
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('deleteAreasRatingService ', error);
    }
}

export const restoreAreasRatingService = async (id: string, value?: string, page: number = 1, status?: number) => {
    try {
        return await http.patchTable<any>(`/v1/ratings/areas-ratings/${id}/restore`, {
            param: value || '',
            page: page,
            status: status
        });
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('restoreAreasRatingService ', error);
    }
}
